import { Box, Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { isCurrentColorModeDark } from "../../../providers/Theme";

export default function TabNavigation(props: { integracaoSinter?: boolean; municipio?: string }) {
  const isPortoPecem = props.municipio?.toLowerCase() === "portopecem";
  const sections = [
    isPortoPecem ? "Área" : "Lote",
    isPortoPecem ? "Formulários" : "Imobiliário",
    "Pessoa",
    ...(!isPortoPecem ? ["Edificações"] : []),
    isPortoPecem ? "Planos de ação - RNC" : props.municipio?.toLowerCase() === "mariana" ? "Averbações" : "Mensagens",
    isPortoPecem ? "Controle" : "Visitas & Controle",
  ];
  const navigate = useNavigate();

  const styles = {
    color: isCurrentColorModeDark() ? "#C7D0DD" : "#1C2025",
    flexWrap: "wrap",
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function scrollToSection(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    handleClose();
  }

  function handleMouseEnter(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleOpenSinterAuditoria() {
    navigate("/auditoria/sinter");
  }

  return (
    <>
      <Button
        id="button"
        color="inherit"
        aria-controls={open ? "menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
      >
        Acesso rápido
      </Button>

      {props.integracaoSinter && (
        <Button color="inherit" onClick={handleOpenSinterAuditoria}>
          SINTER
        </Button>
      )}

      <Box sx={{ position: "absolute" }}>
        <Menu
          id="menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "button",
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          {sections.map((section, index) => (
            <MenuItem key={index} onClick={() => scrollToSection(section)} sx={styles}>
              {section}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </>
  );
}
